import { formatDate } from '@angular/common';
import { Pipe, PipeTransform, Inject, LOCALE_ID  } from '@angular/core';

@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private locale: string) {}

    transform(value: any, format: string = 'mediumDate', timezone?: string): string | null {
        const date = formatDate(value, format, this.locale, timezone);

        if (this.locale === 'pt-PT') {
            const formattedDate = date.replace(/([a-zA-Z]+)\.,/g, '$1');
            return this.capitalizeFirstLetter(formattedDate);
        }
        return date;
    }

    capitalizeFirstLetter(dateString: string): string {
        return dateString.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
    }
}
